// снижение прозрачности меню при прокрутке страницы вниз
const menuOpacity = function() {
  const opacityRange = 500;

  const el = document.querySelector('.fixed-menu');
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const currentBgStr = window.getComputedStyle( el ).backgroundColor;

  // получение массива rgba
  let currentBg = currentBgStr.match(/[\d\.]+/g).map(Number);
  // установка 3-го элемента (прозрачность)
  currentBg[3] = 0 + ( (scrollTop / opacityRange < 1) ? ( scrollTop / opacityRange ) : 1 );
  el.style.backgroundColor = 'rgba(' + currentBg.toString() + ')';
}


const toggleMenu = function() {
  const menu = document.querySelector('.main-menu__wrapper');

  if (!menu.classList.contains('main-menu__visible')) {
    menu.classList.add('main-menu__visible');
  } else {
    menu.classList.remove('main-menu__visible');
  }
}


const hideMenu = function() {
  const menu = document.querySelector('.main-menu__wrapper');
  menu.classList.remove('main-menu__visible');
}


document.addEventListener('DOMContentLoaded', function() {

  menuOpacity();
  window.addEventListener('scroll', menuOpacity);

  const menuButton = document.querySelector('.main-menu__button');
  const menu = document.querySelector('.main-menu__list-wrapper');

  menuButton.addEventListener('click', toggleMenu);
  menu.addEventListener('click', hideMenu);


})
